<template>
  <v-container fluid class="wellon-bg">
    <v-row v-if="sistemas.length" class="mb-4">
      <v-col class="d-flex justify-content-between align-center">
        <img
          src="/media/comunicante/logo-header-wellon.png"
          alt="Logo"
          href="https://wellon.digital"
        />
        <h1 class="m-0 p-0 d-flex align-items-center">Sistemas Integrados</h1>
        <span class="search-wrapper p-input-icon-left">
          <i style="color: #4a148c" class="pi pi-search ml-2" />
          <InputText
            type="text"
            v-model="filtroSistemas"
            placeholder="Pesquisar por nome do sistema..."
            class="wellon-search"
          />
        </span>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col
        v-for="sistema in sistemasFiltrados"
        :key="sistema.sistema_id"
        cols="12"
        sm="6"
        md="3"
        class="d-flex"
      >
        <div class="card-wrapper d-flex flex-grow-1">
          <v-card
            class="wellon-card d-flex flex-column flex-grow-1 mb-2 mr-2"
            elevation="0"
          >
            <div class="logo-container">
              <v-img
                :src="sistema.sis_logo_url"
                height="90"
                width="90"
                contain
                class="mx-auto"
              ></v-img>
            </div>

            <v-card-text
              class="d-flex flex-column justify-center align-center flex-grow-1 pt-2"
            >
              <h2 class="card-title mb-3">
                {{ sistema.sis_nome }}
              </h2>

              <div
                v-if="sistema.bancos && sistema.bancos.length"
                class="d-flex justify-center flex-wrap tags-container w-100"
              >
                <v-chip
                  v-for="banco in sistema.bancos"
                  :key="'banco-' + banco.sistema_banco_id"
                  class="wellon-chip-primary ma-1 mr-1 mb-1"
                  small
                >
                  <v-icon left small class="white--text">{{
                    banco.icon
                  }}</v-icon>
                  {{ banco.banco_nome }}
                </v-chip>
              </div>

              <div v-else class="text-caption grey--text mt-2">
                Sem integrações ativas
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PublicApiService from "@/core/services/public-api.service";
import InputText from "primevue/inputtext";

PublicApiService.init();

export default {
  name: "SistemasIntegrados",
  components: {
    InputText
  },
  data() {
    return {
      loading: false,
      filtroSistemas: "",
      sistemas: []
    };
  },
  computed: {
    // Computed de 'contas' removido pois não usamos mais na UI

    tiposDosSistemas() {
      const tiposSet = new Set();
      this.sistemas.forEach((sistema) => {
        sistema.bancos.forEach((banco) => {
          banco.mt_tipos.forEach((tipo) => {
            tiposSet.add(tipo);
          });
        });
      });
      return Array.from(tiposSet).sort();
    },

    sistemasFiltrados() {
      const filterByNome = this.filtroSistemas
        ? this.sistemas.filter((sistema) => {
            return sistema.sis_nome
              .toLowerCase()
              .includes(this.filtroSistemas.toLowerCase());
          })
        : this.sistemas;

      return filterByNome;
    }
  },
  methods: {
    fetchSistemas() {
      this.loading = true;
      setTimeout(async () => {
        const response = await PublicApiService.get("integracoes");
        if (response.data.status === "success") {
          this.sistemas = response.data.data.sistemas;
          // Removida a lógica de map para 'mostrarTodos'
        } else {
          await this.$store.dispatch("setAlert", {
            type: "error",
            message: response.data.message
          });
        }
        this.loading = false;
      }, 1000);
    }
    // Métodos 'clientesUnicos' e 'clientesLimitados' removidos
  },
  mounted() {
    this.fetchSistemas();
  }
};
</script>

<style scoped>
/* VARIÁVEIS GERAIS */
.wellon-bg {
  background-color: #f4f0f7; /* Lilás Claro */
  min-height: 100vh;
  padding: 30px;
}

/* SEARCH BAR */
.search-wrapper {
  position: relative;
  max-width: 400px;
}

.wellon-search {
  width: 100%;
  padding: 15px 20px 15px 45px;
  border-radius: 15px;
  border: none;
  background: #ffffff;
  box-shadow: 0 4px 15px rgba(74, 20, 140, 0.05);
  color: #333;
  font-family: inherit;
  outline: none;
  transition: box-shadow 0.3s ease;
}

.wellon-search:focus {
  box-shadow: 0 4px 20px rgba(74, 20, 140, 0.15);
}

.search-icon {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

/* CARDS */
.card-wrapper {
  width: 100%;
  /* Altura reduzida já que não há lista de clientes */
  min-height: 250px;
}

.wellon-card {
  background-color: #ffffff;
  border-radius: 20px !important;
  padding: 25px 20px;
  border: none !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04) !important;
  transition: all 0.3s ease;
  position: relative;
}

.wellon-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(74, 20, 140, 0.12) !important;
}

.logo-container {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.card-title {
  color: #4a148c; /* Roxo Escuro */
  font-weight: 700;
  font-size: 1.2rem;
  letter-spacing: -0.5px;
  text-align: center;
}

/* CHIPS / TAGS */
.wellon-chip-primary {
  /* Gradiente Laranja/Amarelo */
  background: linear-gradient(90deg, #ffb74d 0%, #ff9800 100%) !important;
  color: #ffffff !important;
  font-weight: 600;
  border-radius: 50px !important;
  box-shadow: 0 4px 10px rgba(255, 152, 0, 0.25);
  padding: 0 12px;
}
</style>
